export enum InternalEndpoints {
  GetPublicSettings = 'gemini/getPublicSettings',
  GetPayloadData = 'gemini/getPayloadData',
  FindPayloadData = 'gemini/findPayloadData',
}
